<template>
  <div>
    <div v-if="detailDevisCommande" class="is-flex pdt-20px columns is-multiline">
      <div class="corps column is-10">
        <user-warning-message
          :users="[
            { id: devisCommande.commercialId, msg: 'utilisateur.warning.commercialArchive' },
            { id: devisCommande.assistantId, msg: 'utilisateur.warning.assistantArchive' },
          ]"/>
        <div class="steps-detail">
          <dot-steps
            :steps="commandeSteps"
            :current-step="etatCommande"
            :icons="stepIcons">
          </dot-steps>
        </div>
        <facture-information
          :facture="detailDevisCommande"
          :factureDetail="devisCommande"/>
      </div>
      <div class="column is-2">
        <div class="sticky-20px">
          <dots-menu :steps="steps"/>
          <information-create-update-user :data="devisCommande"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DotsMenu from '@/components/general/dotsMenu';
import DotSteps from '@/components/general/dotSteps';
import FactureInformation from '@/components/factures/factureInformation';
import UserWarningMessage from '@/components/commun/user/userWarningMessage';
import InformationCreateUpdateUser from '@/components/general/informationCreateUpdateUser';
import * as devisConf from '@/configuration/devisConf';
import { columnsSplice } from '@/services/general/columns';

export default {
  components: {
    DotSteps,
    DotsMenu,
    FactureInformation,
    InformationCreateUpdateUser,
    UserWarningMessage,
  },
  props: {
    detailDevisCommande: Object,
    devisCommande: Object,
  },
  data() {
    return {
      constantes: {
        ETAT_SANSSUITE: devisConf.ETAT_SANSSUITE,
      },
      stepIcons: [
        {
          step: devisConf.ETAT_SANSSUITE,
          icon: 'close-thick',
          customClassMarker: 'is-hollow is-danger has-text-danger',
        },
      ],
    };
  },
  computed: {
    isBonReception() {
      return this.devisCommande.sousType === devisConf.SOUS_TYPE_BON_RECEPTION;
    },
    prefixTrad() {
      return this.isBonReception ? 'detailBonReception' : 'detailCommandeAchatFournisseur';
    },
    steps() {
      return [
        {
          name: this.$t(`${this.prefixTrad}.anchor.commande`),
          ref: '#detail-command',
          active: true,
        },
        {
          name: this.$t(`${this.prefixTrad}.anchor.comments`),
          ref: '#detail-comments',
          active: false,
        },
        {
          name: this.$t(`${this.prefixTrad}.anchor.piecesJointes`),
          ref: '#attachments',
          active: false,
        },
      ];
    },
    commandeSteps() {
      if (this.isBonReception) {
        const etatBon = [
          devisConf.ETAT_CREE,
          devisConf.ETAT_RAPPROCHE_PARTIELLEMENT,
          devisConf.ETAT_RAPPROCHE,
          devisConf.ETAT_FACTURE,
        ];
        if (this.devisCommande.bonReceptionEtat !== devisConf.ETAT_RAPPROCHE_PARTIELLEMENT) {
          columnsSplice(etatBon, devisConf.ETAT_RAPPROCHE_PARTIELLEMENT);
        }
        return etatBon;
      }
      if (this.devisCommande.etat === devisConf.ETAT_SANSSUITE) {
        return [
          devisConf.ETAT_ENREGISTRE,
          devisConf.ETAT_SANSSUITE,
          devisConf.ETAT_RECEPTIONNEE,
          devisConf.ETAT_FACTURE,
        ];
      }
      const etats = [
        devisConf.ETAT_ENREGISTRE,
        devisConf.ETAT_RECEPTIONNEE_PARTIELLEMENT,
        devisConf.ETAT_RECEPTIONNEE,
        devisConf.ETAT_FACTURE_PARTIELLEMENT,
        devisConf.ETAT_FACTURE,
      ];
      if (this.devisCommande.etat !== devisConf.ETAT_RECEPTIONNEE_PARTIELLEMENT) {
        columnsSplice(etats, devisConf.ETAT_RECEPTIONNEE_PARTIELLEMENT);
      }
      if (this.devisCommande.etat !== devisConf.ETAT_FACTURE_PARTIELLEMENT) {
        columnsSplice(etats, devisConf.ETAT_FACTURE_PARTIELLEMENT);
      }
      return etats;
    },
    etatCommande() {
      return this.isBonReception
        ? this.devisCommande.bonReceptionEtat
        : this.devisCommande.etat;
    },
  },
};
</script>
